import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil, finalize } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { StorageService } from 'src/app/services/storage.service';
import { OperatoriService } from 'src/app/platform/nomenclatoare/operatori/operatori.service';
import { MatDialog } from '@angular/material/dialog';
import { FunctieSelectionDialogComponent } from '../functie-selection-dialog/functie-selection-dialog.component';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { OperatorAccess, UserFunction } from 'src/app/platform/nomenclatoare/operatori/operatori.interface';
import { DirectieSelectionDialogComponent } from '../directie-selection-dialog/directie-selection-dialog.component';


@Component({
    selector: 'app-directie-type-switcher',
    templateUrl: './directie-type-switcher.component.html',
    styleUrls: ['./directie-type-switcher.component.scss']
})
export class DirectieTypeSwitcherComponent {
    private destroy$ = new Subject<void>();

    currentUser: any = null;
    userAccesses: OperatorAccess[] = [];
    activeAccess: OperatorAccess | null = null;
    isLoading = false;

    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    successIcon: string = environment.config.customNotifications.icons.success;
    helper = helper;

    constructor(
        private storageService: StorageService,
        private operatoriService: OperatoriService,
        private notificationService: NotificationService,
        private dialog: MatDialog
    ) { }

    ngOnInit(): void {
        this.loadCurrentUser();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private loadCurrentUser(): void {
        this.storageService.getObject(environment.config.userKey)
            .then((user) => {
                this.currentUser = user;
                this.loadUserAccesses();
            })
            .catch((error) => {
                console.error('Error loading current user:', error);
            });
    }

    private loadUserAccesses(): void {
        if (!this.currentUser?.id_user) {
            return;
        }

        this.isLoading = true;

        this.operatoriService.getOperatorAccess()
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => {
                    this.isLoading = false;
                })
            )
            .subscribe({
                next: (response) => {
                    this.userAccesses = response.data || [];
                    this.activeAccess = this.userAccesses.find(access => access.active) || null;

                    // If user has accesses but no active access, show selection dialog
                    if (this.userAccesses.length > 0 && !this.activeAccess) {
                        this.showAccessesSelectionDialog();
                    }
                },
                error: (error) => {
                    console.error('Error loading user accesses:', error);

                    // Don't show error for new users (404 expected)
                    if (error.status !== 404) {
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            'Eroare la încărcarea acceselor utilizatorului',
                            this.errorIcon
                        );
                    }
                }
            });
    }

    private showAccessesSelectionDialog(): void {
        const dialogRef = this.dialog.open(DirectieSelectionDialogComponent, {
            width: '500px',
            disableClose: true,
            autoFocus: false,
            data: {
                user: this.currentUser,
                accesses: this.userAccesses
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result?.success) {
                // Reload functions after selection
                this.loadUserAccesses();
            }
        });
    }

    shouldShowNoAccessWarning(): boolean {
        return this.userAccesses.length === 0 && !this.isLoading;
    }

    onManageAccesses(): void {
        this.showAccessesSelectionDialog();
    }
}
